import type { DataType } from '@glueapp/graph-types';
import type { ThemeType } from '@/theme/glueTheme';

export function getColorFromDataType(dataType: DataType, theme: ThemeType): string {
    if (!dataType) {
        return 'grey';
    }
    switch (dataType.kind) {
        case 'string':
        case 'stringLiteral':
            return '#2868ee';
        case 'number':
        case 'numberLiteral':
            return '#4caa48';
        case 'boolean':
            return '#d38228';
        case 'object':
            return '#764be0';
        case 'shape':
            return '#c80798';
        case 'array':
            return 'grey';
        case 'union':
            return '#a36ba4';
        case 'generic':
            if (dataType.resolvedType) {
                return getColorFromDataType(dataType.resolvedType, theme);
            }
            return '#282828';
        case 'function':
            return '#08d3ed';
        case 'null':
            return theme.primaryContrastColor;
        case 'secret':
            return '#e6a817';
        case 'optional':
            return getColorFromDataType(dataType.innerType, theme);
    }
}
